import React, { useContext, useState, useEffect } from 'react'
import { useIntl } from 'react-intl'
import { SessionContext, AppContext } from 'contexts'
import { columns, handlers } from 'models/inventoryDrawer'
import { Drawer, Table } from 'components/core'
import { initialPage } from 'utilities/pagination'

export default ({ value, open, action }) => {
  const { formatMessage: message } = useIntl()
  const session = useContext(SessionContext)
  const app = useContext(AppContext)
  const [state, setState] = useState()
  const [pagination, setPagination] = useState(initialPage())
  const { handleLoad } = handlers({
    setState,
    session,
    app,
    value,
    setPagination,
  })

  useEffect(() => {
    handleLoad()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])

  return (
    <Drawer
      width={[1, '600px']}
      title={`inventory.title.history`}
      open={open}
      onClose={action.handleClose}
    >
      <Table
        columns={columns(message)}
        rows={state}
        pagination={pagination}
        onChange={handleLoad}
      />
    </Drawer>
  )
}
